import React from "react";
import { Outlet } from "react-router-dom";
import useAuth from "@hook/useAuth";
import PleaseLogin from "@pages/home/PleaseLogin";

const Private = () => {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? <Outlet /> : <PleaseLogin />;
};

export default Private;
